import exp from "constants";
import { EWidgetChartTypes } from "../types/overview.types";

export const verticalLabelFormatter = (v: number) =>
  !!v && !isNaN(v) && v.toString().includes("-")
    ? `-${compactNumberIntl(v)}` // -$120K
    : `${compactNumberIntl(v)}`; // $120K

export const compactNumberIntl = (n: number) => {
  // -ve values

  if (n < 0 && n > -1e1) {
    return -n.toFixed(1);
  }
  if (n <= -1e1 && n > -1e3) {
    return -n.toFixed(0);
  }
  if (n <= -1e3 && n > -1e4) {
    return -(n / 1e3).toFixed(1) + "k";
  }
  if (n <= -1e4 && n > -1e6) {
    return -(n / 1e3).toFixed(0) + "k";
  }
  if (n <= -1e6 && n > -1e7) {
    return -(n / 1e6).toFixed(1) + "m";
  }
  if (n <= -1e7 && n > -1e9) {
    return -(n / 1e6).toFixed(0) + "m";
  }
  if (n <= -1e9 && n > -1e10) {
    return -(n / 1e9).toFixed(1) + "b";
  }
  if (n <= -1e10 && n > -1e12) {
    return -(n / 1e9).toFixed(0) + "b";
  }
  if (n <= -1e12) {
    return -(n / 1e12).toFixed(1) + "t";
  }

  // +ve values

  if (n > 0 && n < 1e1) {
    return n.toFixed(0);
  }
  if (n >= 1e1 && n < 1e3) {
    return n.toFixed(0);
  }
  if (n >= 1e3 && n < 1e4) {
    return +(n / 1e3).toFixed(1) + "k";
  }
  if (n >= 1e4 && n < 1e6) {
    return +(n / 1e3).toFixed(0) + "k";
  }
  if (n >= 1e6 && n < 1e7) {
    return +(n / 1e6).toFixed(1) + "m";
  }
  if (n >= 1e7 && n < 1e9) {
    return +(n / 1e6).toFixed(0) + "m";
  }
  if (n >= 1e9 && n < 1e10) {
    return +(n / 1e9).toFixed(1) + "b";
  }
  if (n >= 1e10 && n < 1e12) {
    return +(n / 1e9).toFixed(0) + "b";
  }
  if (n >= 1e12) {
    return +(n / 1e12).toFixed(1) + "t";
  }
};

export const getChartTypeIdByName = (name: string) => {
  switch (name) {
    case EWidgetChartTypes.PIE:
      return 1;
    case EWidgetChartTypes.DOUGHNUT:
      return 2;
    case EWidgetChartTypes.VERTICAL_BAR_GRAPH:
      return 3;
    case EWidgetChartTypes.HORIZONTAL_BAR_GRAPH:
      return 4;
    case EWidgetChartTypes.STACKED_BAR_GRAPH:
      return 5;
    case EWidgetChartTypes.LINE_GRAPH:
      return 6;
    default:
      return null;
  }
};

export const getChartTypeNameById = (id: number) => {
  switch (id) {
    case 1:
      return EWidgetChartTypes.PIE;
    case 2:
      return EWidgetChartTypes.DOUGHNUT;
    case 3:
      return EWidgetChartTypes.VERTICAL_BAR_GRAPH;
    case 4:
      return EWidgetChartTypes.HORIZONTAL_BAR_GRAPH;
    case 5:
      return EWidgetChartTypes.STACKED_BAR_GRAPH;
    case 6:
      return EWidgetChartTypes.LINE_GRAPH;
    default:
      return null;
  }
};
